<template>
	<div class="payment-loader">
		<content-loader
			:width="335"
			:height="309"
			:speed="3"
			:primaryColor="primaryColor"
			:secondaryColor="secondaryColor"
		>
			<rect x="0" y="18" rx="0" ry="0" width="100" height="19" />
			<rect x="0" y="46" rx="0" ry="0" width="333" height="14" />
			<rect x="0" y="77" rx="0" ry="0" width="75" height="42" />
			<rect x="87" y="77" rx="0" ry="0" width="75" height="42" />
			<rect x="260" y="77" rx="0" ry="0" width="75" height="42" />
			<rect x="174" y="77" rx="0" ry="0" width="75" height="42" />
			<rect x="-1" y="135" rx="0" ry="0" width="344" height="46" />
			<rect x="0" y="193" rx="0" ry="0" width="203" height="53" />
		</content-loader>
	</div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
export default {
	components: { ContentLoader },
	computed: {
		primaryColor() {
			return window
				.getComputedStyle(document.body)
				.getPropertyValue("--light-gray")
				.replace(" ", "");
		},
		secondaryColor() {
			return window
				.getComputedStyle(document.body)
				.getPropertyValue("--main-bg-color")
				.replace(" ", "");
		},
	},
};
</script>

<style lang="scss" scoped>
.payment-loader {
	background: var(--white);
}
</style>
